<template>
    <section> 
        <ui-create-task-modal name="global-deals-create-task" customer-change-option :show-close-option="false" />  
    </section>
</template>
<script>
    import { uiCreateTaskModal } from '@/components/ui-facilita/modals'
	export default {
        components: {
            uiCreateTaskModal,
        },

        mounted() {
            this.$root.$emit('modal-open-global-deals-create-task', false, false, true)
        }
    }
</script>